import { Component, OnInit, Input } from '@angular/core';
import { Banner } from '../../models/banner.model';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styles: []
})
export class BannerComponent implements OnInit {
  @Input() banners: Banner[];
  constructor() { }

  ngOnInit() {
  }

}
